import { isFeature } from 'Cloud/Application/FeaturesEs6';

/**
 * Переключает отображение фастскролл-галереей и обычной галереей на новые кропнутые тамбы
 */
export const galleryCroppedThumbs = isFeature('gallery-cropped-thumbs');
